// Logo Component - hello, social
// Cole este componente em um arquivo separado: components/Logo.jsx

import React from 'react';

const Logo = ({ className = "h-8", showSocial = true }) => {
  return (
    <div className={`${className} flex items-center`}>
      <div className="flex items-baseline">
        {/* "hello," em preto */}
        <span className="font-bold text-black" style={{ 
          fontSize: 'inherit',
          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
          letterSpacing: '-0.02em'
        }}>
          hello
        </span>
        {/* vírgula em laranja/amarelo */}
        <span className="font-bold" style={{ 
          color: '#FFB800',
          fontSize: 'inherit',
          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
        }}>
          ,
        </span>
      </div>
      
      {/* "social" embaixo se showSocial for true */}
      {showSocial && (
        <span className="ml-1 font-normal text-black tracking-widest" style={{ 
          fontSize: '0.35em',
          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
          letterSpacing: '0.3em',
          position: 'relative',
          top: '0.15em'
        }}>
          social
        </span>
      )}
    </div>
  );
};

export default Logo;